<template>
  <div>
    <PageTitle :route="$route"> </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <CauseOfMaintanceForm
          v-if="causeOfMaintance"
          :causeOfMaintance="causeOfMaintance"
        />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import CauseOfMaintanceForm from "@/components/settings/test-registers/causeOfMaintance/CauseOfMaintanceForm.vue";

export default {
  name: "CauseOfMaintance",
  components: {
    PageTitle,
    PageRowWrapper,
    CauseOfMaintanceForm,
  },
  computed: {
    ...mapState({
      causeOfMaintance: (state) => state.causeofmaintance.causeOfMaintanceById,
    }),
  },
  methods: {
    ...mapActions("causeofmaintance", ["fetchById"]),
  },
  mounted() {
    this.fetchById(this.$route.params.id);
  },
};
</script>
